/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import { useEffect, useState } from "react";
import { Button, Input, Segment } from "semantic-ui-react";
import TextareaAutosize from 'react-textarea-autosize';
import { changeTool } from "../slices/footer/footerSlice";
import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const usdmToFevirCall = async (usdmValue = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!usdmValue) {
        console.log("no usdmValue");
        return null;
    }
    console.log("CALLING SERVER with usdmtofevirconverter")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'usdmtofevirconverter',
            'apiToken': apiToken,
            'tool': "usdmtofevirconverter",
            'usdm': usdmValue,
            'usdmfile': JSON.parse(usdmValue)
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from usdmtofevirconverter call");
    }).catch((error) => { console.log(error); });
};

const convertUSDMtoFHIR = async (apiToken, usdmEntryState, setFhirOutputState) => {

    let usdmValue = usdmEntryState.text || usdmEntryState.usdmFile;
    let response = await usdmToFevirCall(usdmValue, apiToken);
    if (response.success === false) {
        alert("We were unable to convert this USDM data. Check the formatting, and let us know if you need us to investigate.");
    } else {
        if (response["jsonarraystring"]) {
            let jsonarray = JSON.parse(response["jsonarraystring"]);
            if (setFhirOutputState) {
                setFhirOutputState(JSON.stringify(jsonarray, null, 2));
            }
            return jsonarray;
        }
    }
}; 

const UsdmInputForm = ({ usdmEntryState, setUsdmEntryState }) => {

    return <div>
        <h3>USDM JSON</h3>
        <textarea style={{ width: "100%" }} rows={14} type='text'
            value={usdmEntryState.text || ''}
            onChange={(e) => {
                setUsdmEntryState(prevState => {
                    return {
                        ...prevState,
                        text: e.target.value,
                        usdmFile: ""
                    };
                });
            }} />
        <br /><br />
        <Input id="inputUsdmFile"
            type="file"
            accept=".json,.txt"
            onChange={(e, data) => {
                if (e.target.files.length > 0) {
                    let file = e.target.files[0];
                    try {
                        let reader = new FileReader();
                        reader.readAsText(file);

                        reader.onload = function () {
                            if (reader.result.length < 70000000) {
                                setUsdmEntryState(prevState => {
                                    return {
                                        ...prevState,
                                        text: "",
                                        usdmFile: reader.result
                                    };
                                });
                            } else {
                                alert("We only support attaching files that are 50 MB or less. If your file is larger, then please email support@computablepublishing.com"); //We'll leave this for now until we have a way to test/trigger this, because I'll need to test with modals overlapping
                            }
                        };
                        reader.onerror = function (error) {
                            console.log('Error, ', error);
                        };
                    } catch (e) {
                        console.log(e);
                        alert("File could not be processed."); //We'll leave this for now until we have a way to test/trigger this, because I'll need to test with modals overlapping
                    }
                }
            }}
        />
        <br />
    </div>
}

// eslint-disable-next-line no-empty-pattern
const USDMtoFEvIRConverterPage = ({ }) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);

    const [usdmEntryState, setUsdmEntryState] = useState({
        "text": "",
        "usdmFile": ""
    });
    const [fhirOutputState, setFhirOutputState] = useState("");

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR USDM-to-FEvIR Converter"));
        dispatch(changeTool("Computable Publishing®: USDM-to-FEvIR Converter"));
    }, []);

    return (
        <div>
            <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
                <UsdmInputForm usdmEntryState={usdmEntryState}
                 setUsdmEntryState={setUsdmEntryState} />
                <br />
                <Button className="formButton positive"
                 content="Convert USDM to FEvIR" compact
                    onClick={() => { 
                        convertUSDMtoFHIR(apiToken, usdmEntryState, setFhirOutputState); 
                    }} />
                <br />
                {
                    fhirOutputState &&
                    <Button className="formButton" content="Copy JSON" compact
                        onClick={() => { navigator.clipboard.writeText(fhirOutputState); }}
                        disabled={!fhirOutputState ? true : false} />
                }
                <h3>JSON Output</h3>
                <TextareaAutosize style={{ width: "98%", color: "#000000" }}
                    spellCheck="false"
                    value={fhirOutputState} />
                <br /><br />
                {
                    fhirOutputState &&
                    <Button className="formButton" content="Copy JSON" compact
                        onClick={() => { navigator.clipboard.writeText(fhirOutputState); }}
                        disabled={!fhirOutputState ? true : false} />
                }
            </Segment>
        </div>
    );
};

export default USDMtoFEvIRConverterPage;